import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { RoutingService } from '@spartacus/core'
import { CustomFormValidators } from '@spartacus/storefront'
import { CustomRoutes } from '../../../../../../models/enum/custom-routes.enum'
import { IAgreement, IAgreementAcceptReject } from '../../../../../../models/interface/agreement.interface'
import { PriceSupportAgreementService } from '../../../../../../services/agreement/price-support/price-support-agreement.service'
import { SharedService } from '../../../../../../services/shared/shared.service'

@Component({
    selector: 'app-price-agreement-reject',
    templateUrl: './price-agreement-reject.component.html',
    styleUrls: ['./price-agreement-reject.component.scss'],
    standalone: false
})
export class PriceAgreementRejectComponent implements OnInit {
  public data: IAgreementAcceptReject
  public rejectForm: FormGroup
  public showSpinner = false

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private routingService: RoutingService,
    private priceSupportAgreementService: PriceSupportAgreementService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.rejectForm = this.formBuilder.group({
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      reason: ['', [Validators.required]]
    })
  }

  public onShowDetails(): void {
    this.sharedService
      .getQueryParams()
      .subscribe((params) => {
        const queryParam = {
          [CustomRoutes.PRICE_SUPPORT_AGREEMENT_HISTORY]: { page: params.page }
        }
        this.sharedService.setQueryParamsLocal(queryParam)
      })
      .unsubscribe()

    this.modal.close()
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go({
      cxRoute: CustomRoutes.PRICE_SUPPORT_AGREEMENT_DETAILS,
      params: { code: this.data.agreement.orderCode }
    })
  }

  public getTermsAndConditions(agreement: IAgreement): void {
    this.priceSupportAgreementService.getTermsAndConditionsPDF(agreement)
  }

  onSubmit(): void {
    if (this.rejectForm.valid) {
      const code = this.data.agreement.orderCode
      const email = this.rejectForm.get('email').value.trim()
      const reason = this.rejectForm.get('reason').value.trim()

      this.showSpinner = true
      this.priceSupportAgreementService.rejectAgreement(code, email, reason).subscribe(
        () => {
          this.showSpinner = false
          this.modal.close(code)
        },
        (err) => {
          this.modal.dismiss(err)
        }
      )
    } else {
      this.rejectForm.markAllAsTouched()
    }
  }
}
